var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modifiers',_vm._b({on:{"update":_vm.update}},'modifiers',[_vm.modifiers, {query: _vm.query}],false))}
var staticRenderFns = []

export { render, staticRenderFns }